var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.qr)?_c('div',{staticClass:"qr",attrs:{"data-testid":"payment-qr"}},[(_vm.src)?_c('img',{staticClass:"qr-image",attrs:{"src":_vm.src,"alt":"QR ชำระเงิน"}}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }